var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "185.955mm",
    height: "73.1818mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 18595.52 7318.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil0 {fill:black}\r\n  \r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1886538288800"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7144.74 4149.55c0,-690.82 360.91,-1051.75 1051.75,-1051.75l2482.11 0c1191.84,0 1009.68,941.26 1009.68,1640.71l-4543.54 0 0 -588.96zm-546.91 -252.42l0 2103.48c0,383.49 268.78,715.07 472.34,915.95 242.73,239.61 577.03,388.19 1042.18,388.19l3660.07 0c180.04,0 336.56,-129.67 336.56,-294.49 0,-432.96 -833.05,-294.49 -1262.1,-294.49 -492.01,0 -2826.87,56.1 -3110.18,-45.05 -608.7,-217.34 -591.96,-781.2 -591.96,-1343.23l4795.96 0c474.67,0 336.56,-646.13 336.56,-1388.29 0,-745.12 -706.01,-1388.28 -1304.17,-1388.28l-3029.02 0c-694.37,0 -1346.24,651.84 -1346.24,1346.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M539.78 5664.05l0 -2524.18 3828.34 0c304.37,0 757.26,365.68 757.26,925.54l0 1724.85c0,551.63 -373.9,925.51 -925.54,925.51l-2734.52 0c-625.76,0 -925.54,-441.97 -925.54,-1051.72zm-546.91 -5426.96l0 5721.45c0,712.99 678.41,1346.21 1514.52,1346.21 792.91,0 2744.35,97.07 3319.02,-130.69 201.38,-79.82 326.42,-212.26 478.51,-362.87 540.11,-534.79 409.44,-1592.58 409.44,-2493.36 0,-552.82 -70.85,-851.99 -359.52,-1239.13 -198.38,-266.02 -626.83,-527.78 -1070.86,-527.78l-3744.2 0 0 -2313.83c0,-308.9 -546.91,-304.32 -546.91,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M12866.24 3728.85c0,583.81 164.99,1010.63 728.26,1291.08 474.41,236.2 913.54,181.35 1585.59,181.35 694.27,0 2043.68,-104.84 2481.91,168.47 663.77,414.02 265.49,1289.76 -463.03,1345.57l-3028.56 0.45c-389.08,0 -1304.17,-128.26 -1304.17,252.42 0,203.51 133.05,336.56 336.56,336.56l3828.34 0c425.28,0 831,-161.7 1062.39,-367.97 747.58,-666.49 620.53,-1608.89 -195.09,-2097.94 -418.55,-250.96 -932.91,-226.52 -1582.49,-226.52 -602.83,0 -1206.53,-3.2 -1809.27,0.26 -1527.56,8.83 -1296.08,-1451.72 -212.07,-1474.69l3367.61 1.98c280.2,0.19 586.11,44.29 736.51,-106.08 195.32,-195.33 34.65,-482.87 -147.56,-482.87l-3996.62 0c-680.16,0 -1388.31,616.02 -1388.31,1177.93z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesLogo);
export default __webpack_public_path__ + "static/media/BesLogo.ef485ac9559f185aefc82284f25158f4.svg";
export { ForwardRef as ReactComponent };